import axios from "axios";
import {base_url} from '../global'

const apiPortal = axios.create({
    baseURL: base_url,
    withCredentials: false,
    headers: {
        "tipoNota": "AVULSA",
        Accept: "application/json",
        "Content-Type": "application/json",
    },
});

const promiseGestaoConteudo = apiPortal.post("/notafiscal-ws/servico/gestao-conteudo/")

export default {
    getConteudo() {
        // return apiPortal.get("https://homolmcp2.dsfweb.com.br/notafiscal-ws/servico/gestao-conteudo");
        return promiseGestaoConteudo;
    },

    getBundle(labelMessage) {
        console.log("Chamando o serviço de Bundle !!!")
        return apiPortal.post("/notafiscal-ws/servico/gestao-conteudo/bundle/", labelMessage)
    }
};
